'use strict';

import { useEffect, useState } from 'react';
import CustomerDataPlatformService from 'utils/network/customer-data-platform/customer-data-platform.service';
import FormCard from 'components/FormCard';
import FormRangeCard from 'components/FormRangeCard';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useNotif } from 'context/NotificationContext';
import {
  STATUS_SUCCESS,
  AUDIENCE_COUNT_PERCENTAGE,
  TYPE_INPUT_DATE,
  TYPE_INPUT_TEXT
} from 'utils/constants';
import { downloadByUrl } from 'utils/DownloadByUrl';
import Loading from 'components/Loading';
import LoadingButton from 'components/LoadingButton';

export default function FormCustomerDataPlatform() {
  const navigate = useNavigate();
  const { notification, setNotification } = useNotif();
  const [dataMaster, setDataMaster] = useState(null);
  const {
    handleSubmit,
    control,
    register,
    setValue,
    formState: { errors }
  } = useForm();
  const { id } = useParams();

  const [isCreate, setIsCreate] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const [audienceCount, setAudienceCount] = useState(null);
  const [audienceCountPercentage, setAudienceCountPercentage] = useState(null);
  const [loading, setLoading] = useState(null);

  const getMasterList = async () => {
    setLoading('master-list');
    let respone;
    let status;
    if (isCreate) {
      respone = await CustomerDataPlatformService.masterFilterList();
    } else {
      respone = await CustomerDataPlatformService.audienceGroupById(id);
    }

    status = respone.status;

    if (status !== STATUS_SUCCESS) {
      const messageRespone = respone.data.message;
      setNotification({
        ...notification,
        show: true,
        title: messageRespone,
        error: true
      });
      navigate('/customer-data-Platform');
    } else {
      if (isCreate) {
        setDataMaster(respone.data.data);
      } else {
        setDataMaster(respone.data.data.filters);
        setValue('title', respone.data.data.title);
        setAudienceCount(respone.data.data.audienceCount);
        setAudienceCountPercentage(respone.data.data.audienceCountPercentage);
      }
    }
    setLoading(null);
  };
  const onSubmit = async (data) => {
    setLoading('submit-data');
    let respone;
    let status;

    if (isCreate) {
      respone = await CustomerDataPlatformService.storeAudienceGroup(data);
    } else {
      respone = await CustomerDataPlatformService.putAudienceGroupById(
        id,
        data
      );
    }

    status = respone.status;
    const messageRespone = respone.data.message;
    if (status !== STATUS_SUCCESS) {
      setNotification({
        ...notification,
        show: true,
        title: messageRespone,
        error: true
      });
    } else {
      navigate('/customer-data-Platform');
      setNotification({
        ...notification,
        show: true,
        title: messageRespone || 'Internal Server Error',
        error: false
      });
    }
    setLoading(null);
  };

  useEffect(() => {
    if (isGetData) {
      getMasterList();
    }
  }, [isGetData, id]);

  useEffect(() => {
    const idNumber = Number(id);
    setIsGetData(false);
    setDataMaster(null);
    if (isNaN(idNumber) && id === 'new') {
      setAudienceCountPercentage(AUDIENCE_COUNT_PERCENTAGE);
      setIsCreate(true);
    } else {
      setIsGetData(true);
    }
  }, [id]);

  const handleDownload = async () => {
    setLoading('download-file');
    const respone = await CustomerDataPlatformService.downloadAudieceGroup(id);
    const status = respone.status;
    if (status !== STATUS_SUCCESS) {
      const messageRespone = respone.data.message;
      setNotification({
        ...notification,
        show: true,
        title: messageRespone,
        error: true
      });
    } else {
      const data = respone?.data?.data;
      const urlCSV = data?.url;
      downloadByUrl(urlCSV);
    }
    setLoading(null);
  };

  return (
    <div>
      <div className="flex flex-row items-center ">
        <h2 className="my-6 text-xl font-semibold text-gray-700 dark:text-gray-200 mr-4">
          {isCreate ? 'Create' : 'Detail'} Audience Group
        </h2>
        {loading === 'master-list' && <Loading />}
      </div>

      <div className=" flex flex-wrap  bg-white  py-1 px-4">
        <div className="w-full md:w-4/5 p-4">
          <div className="bg-white border rounded-lg px-8 py-6 mx-auto  shadow-sm">
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Title
              </label>
              <input
                {...register('title', {
                  required: { value: true, message: 'Title is required' }
                })}
                placeholder="Audience Group 1"
                type="text"
                className={`focus:outline-none placeholder-gray-700 w-full text-sm text-gray-700 flex bg-white border px-3 py-2 shadow-sm rounded-lg  mb-2  ${
                  errors?.title ? 'border-red-600' : ''
                } `}
              ></input>
              <p className="text-xs text-red-600">{errors?.title?.message}</p>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Customer
              </label>
              <div
                className=" w-full"
                onClick={!isGetData ? () => setIsGetData(true) : null}
              >
                <details className="mb-2 group cursor-pointer ">
                  <summary
                    className={`text-sm text-gray-700 flex items-center   justify-between marker:content-none bg-white border px-3 py-2 shadow-sm rounded-lg  mb-2   ${
                      errors?.filters?.customer ? 'border-red-600' : ''
                    } `}
                  >
                    <span className="flex gap-2 ">
                      <span>
                        Suggest Segmentation based on profile customer
                      </span>
                    </span>
                    <svg
                      className="w-5 h-5 text-gray-500 transition group-open:rotate-90"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                      ></path>
                    </svg>
                  </summary>

                  <div
                    className={`grid  md:grid-cols-3  gap-2 mt-2 shadow-sm p-4 rounded-lg  border text-sm  ${
                      errors?.filters?.customer
                        ? 'border-red-600'
                        : 'border-gray-200'
                    }`}
                  >
                    <FormRangeCard
                      titleCard={'Register Date'}
                      dataValue={dataMaster?.customer?.registerDate}
                      nameLabel={{
                        start: 'Register Date Range',
                        end: 'To'
                      }}
                      inputType={TYPE_INPUT_DATE}
                      control={control}
                      name={{
                        start: 'filters.customer.registerDate.start',
                        end: 'filters.customer.registerDate.end'
                      }}
                    />

                    <FormCard
                      titleCard={'Gender'}
                      listOption={dataMaster?.customer?.gender}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.customer.gender"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'Age'}
                      listOption={dataMaster?.customer?.age}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.customer.age"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'Register Device Platform'}
                      listOption={dataMaster?.customer?.registerDevicePlatform}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.customer.registerDevicePlatform"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'Email'}
                      listOption={dataMaster?.customer?.email}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.customer.email"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'Mobile Provider'}
                      listOption={dataMaster?.customer?.mobileProvider}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.customer.mobileProvider"
                      setDefaultValue={setValue}
                    />
                  </div>
                </details>
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Transaction
              </label>
              <div
                className=" w-full"
                onClick={!isGetData ? () => setIsGetData(true) : null}
              >
                <details className="mb-2 group cursor-pointer">
                  <summary
                    className={`text-sm text-gray-700 flex items-center   justify-between marker:content-none bg-white border px-3 py-2 shadow-sm rounded-lg  mb-2   ${
                      errors?.filters?.transaction ? 'border-red-600' : ''
                    } `}
                  >
                    <span className="flex gap-2">
                      <span>
                        Suggest Segmentation based on transactional data
                      </span>
                    </span>
                    <svg
                      className="w-5 h-5 text-gray-500 transition group-open:rotate-90"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                      ></path>
                    </svg>
                  </summary>

                  <div
                    className={`grid  md:grid-cols-3  gap-2 mt-2 shadow-sm p-4 rounded-lg  border text-sm  ${
                      errors?.filters?.transaction
                        ? 'border-red-600'
                        : 'border-gray-200'
                    }`}
                  >
                    <FormRangeCard
                      titleCard={'Transaction Date'}
                      dataValue={dataMaster?.transaction?.transactionDate}
                      nameLabel={{
                        start: 'Transaction Date Range',
                        end: 'To'
                      }}
                      inputType={TYPE_INPUT_DATE}
                      control={control}
                      name={{
                        start: 'filters.transaction.transactionDate.start',
                        end: 'filters.transaction.transactionDate.end'
                      }}
                    />

                    <FormCard
                      titleCard={'Repeat Status'}
                      listOption={dataMaster?.transaction?.repeatStatus}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.transaction.repeatStatus"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'Brand'}
                      listOption={dataMaster?.transaction?.brand}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.transaction.brand"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'payment Method'}
                      listOption={dataMaster?.transaction?.paymentMethod}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.transaction.paymentMethod"
                      setDefaultValue={setValue}
                    />

                    <FormCard
                      titleCard={'Payment Favorite'}
                      listOption={dataMaster?.transaction?.paymentFavorite}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.transaction.paymentFavorite"
                      setDefaultValue={setValue}
                    />
                    <FormRangeCard
                      titleCard={'Frequency'}
                      dataValue={dataMaster?.transaction?.frequency}
                      nameLabel={{
                        start: 'Frequency Range',
                        end: 'To'
                      }}
                      inputType={TYPE_INPUT_TEXT}
                      control={control}
                      name={{
                        start: 'filters.transaction.frequency.start',
                        end: 'filters.transaction.frequency.end'
                      }}
                    />
                    <FormRangeCard
                      titleCard={'Transaction Total'}
                      dataValue={dataMaster?.transaction?.transactionTotal}
                      nameLabel={{
                        start: 'Transaction Total Range',
                        end: 'To'
                      }}
                      inputType={TYPE_INPUT_TEXT}
                      control={control}
                      name={{
                        start: 'filters.transaction.transactionTotal.start',
                        end: 'filters.transaction.transactionTotal.end'
                      }}
                    />
                    <FormRangeCard
                      titleCard={'Sales Total'}
                      dataValue={dataMaster?.transaction?.salesTotal}
                      nameLabel={{
                        start: 'Sales Total Range',
                        end: 'To'
                      }}
                      inputType={TYPE_INPUT_TEXT}
                      control={control}
                      name={{
                        start: 'filters.transaction.salesTotal.start',
                        end: 'filters.transaction.salesTotal.end'
                      }}
                    />

                    <FormCard
                      titleCard={'Persona'}
                      listOption={dataMaster?.transaction?.persona}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.transaction.persona"
                      setDefaultValue={setValue}
                    />
                  </div>
                </details>
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-2">
                Loyalty
              </label>
              <div
                className=" w-full"
                onClick={!isGetData ? () => setIsGetData(true) : null}
              >
                <details className="mb-2 group cursor-pointer">
                  <summary
                    className={`text-sm text-gray-700 flex items-center   justify-between marker:content-none bg-white border px-3 py-2 shadow-sm rounded-lg  mb-2   ${
                      errors?.filters?.loyalty ? 'border-red-600' : ''
                    } `}
                  >
                    <span className="flex gap-2">
                      <span>
                        Suggest Segmentation based on loyalty tier & points
                      </span>
                    </span>
                    <svg
                      className="w-5 h-5 text-gray-500 transition group-open:rotate-90"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                      ></path>
                    </svg>
                  </summary>

                  <div
                    className={`grid  md:grid-cols-3  gap-2 mt-2 shadow-sm p-4 rounded-lg  border text-sm  ${
                      errors?.filters?.loyalty
                        ? 'border-red-600'
                        : 'border-gray-200'
                    }`}
                  >
                    <FormRangeCard
                      titleCard={'Loyalty'}
                      dataValue={dataMaster?.loyalty?.loyaltyPoint}
                      nameLabel={{
                        start: 'Loyalty Point Range',
                        end: 'To'
                      }}
                      inputType={TYPE_INPUT_TEXT}
                      control={control}
                      name={{
                        start: 'filters.loyalty.loyaltyPoint.start',
                        end: 'filters.loyalty.loyaltyPoint.end'
                      }}
                    />

                    <FormCard
                      titleCard={'Tier Level'}
                      listOption={dataMaster?.loyalty?.tierLevel}
                      inputType={'checkbox'}
                      control={control}
                      name="filters.loyalty.tierLevel"
                      setDefaultValue={setValue}
                    />
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/5 p-4 bg-white ">
          <div className=" flex flex-col items-center ">
            <div className="w-full  p-4  rounded-md shadow-md text-center bg-orange-100">
              <p className="font-semibold text-xl">Available External ID</p>
              <p className="mt-3">Filtered Customers</p>
              <div className="flex items-center justify-center mt-5">
                <div className="w-[140px] h-[140px] rounded-full bg-orange-300 flex items-center justify-center">
                  <p className="font-bold text-3xl">
                    {audienceCountPercentage}%
                  </p>
                </div>
              </div>
              <p className="font-bold text-lg mt-3 mb-[70px]">
                {audienceCount?.toLocaleString()}
              </p>
              <div className="flex flex-col space-y-5 items-center ">
                <button
                  onClick={dataMaster && handleSubmit(onSubmit)}
                  className="flex flex-row items-center justify-between  w-[85%] px-5 py-2 mt-4 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-main bg-secondary hover:bg-yellow-700 focus:outline-none"
                >
                  <span>{isCreate ? 'Save ' : 'Update '}</span>
                  <span>
                    {loading === 'submit-data' ? (
                      <LoadingButton />
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.5159 8.51526L3.07121 0.204115C1.7742 -0.495591 0.27239 0.716095 0.681974 2.13257L2.79816 9.53922C2.88349 9.84641 2.88349 10.1536 2.79816 10.4608L0.681974 17.8674C0.27239 19.2839 1.7742 20.4956 3.07121 19.7959L18.5159 11.4847C18.7794 11.3408 18.9993 11.1285 19.1525 10.8703C19.3057 10.612 19.3865 10.3173 19.3865 10.0171C19.3865 9.71681 19.3057 9.42209 19.1525 9.16385C18.9993 8.9056 18.7794 8.69336 18.5159 8.54939V8.51526Z"
                          fill="white"
                        />
                      </svg>
                    )}
                  </span>
                </button>

                <button
                  onClick={!isCreate && dataMaster ? handleDownload : null}
                  className={`flex flex-row items-center justify-between  w-[85%] px-5 py-2 mt-4 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-orange-200  focus:outline-none ${
                    !isCreate && 'hover:bg-orange-700'
                  }`}
                >
                  <span>Download</span>
                  <span>
                    {loading === 'download-file' ? (
                      <LoadingButton />
                    ) : (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 13.5789V19.8947C2 21.0575 2.99492 22 4.22222 22H19.7778C21.0051 22 22 21.0575 22 19.8947V13.5789"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.9999 2V16.7368M11.9999 16.7368L6.44434 11.0058M11.9999 16.7368L17.5554 11.0059"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
